import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getLinks as _getLinks } from "@cinch-nx/data-storyblok";
import { traceFunction } from "@core/datadog-server";
export function getStaticPathsForPage() {
    return /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                {
                    paths: [
                        {
                            params: {
                                page: "2"
                            }
                        }
                    ],
                    fallback: "blocking"
                }
            ];
        });
    });
}
var getLinks = traceFunction("getLinks", _getLinks);
export function getStaticPathForMakes(param) {
    var _requiresPage = param.requiresPage, requiresPage = _requiresPage === void 0 ? false : _requiresPage;
    return /*#__PURE__*/ _async_to_generator(function() {
        var makes, paths;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getTopMakes()
                    ];
                case 1:
                    makes = _state.sent().slice(0, 10);
                    paths = makes.map(function(param) {
                        var make = param.make;
                        return {
                            params: {
                                make: make,
                                page: requiresPage ? "2" : undefined
                            }
                        };
                    });
                    return [
                        2,
                        {
                            paths: paths,
                            fallback: "blocking"
                        }
                    ];
            }
        });
    });
}
export function getStaticPathForModels(param) {
    var _requiresPage = param.requiresPage, requiresPage = _requiresPage === void 0 ? false : _requiresPage;
    return /*#__PURE__*/ _async_to_generator(function() {
        var makes, models, paths;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getTopMakes()
                    ];
                case 1:
                    makes = _state.sent().slice(0, 10);
                    return [
                        4,
                        Promise.all(makes.map(function(param) {
                            var make = param.make;
                            return getTopModelForMake(make);
                        }))
                    ];
                case 2:
                    models = _state.sent().flat();
                    paths = models.map(function(param) {
                        var make = param.make, model = param.model;
                        return {
                            params: {
                                make: make,
                                model: model,
                                page: requiresPage ? "2" : undefined
                            }
                        };
                    });
                    return [
                        2,
                        {
                            paths: paths,
                            fallback: "blocking"
                        }
                    ];
            }
        });
    });
}
function getTopMakes() {
    return _getTopMakes.apply(this, arguments);
}
function _getTopMakes() {
    _getTopMakes = _async_to_generator(function() {
        var links, makes;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getLinks("car-reviews-v2/")
                    ];
                case 1:
                    links = _state.sent();
                    makes = Object.values(links).reduce(function(acc, link) {
                        if (link.is_folder && link.slug !== "car-reviews-v2") {
                            acc.push(link.slug.replace("car-reviews-v2/", ""));
                        }
                        return acc;
                    }, []);
                    return [
                        2,
                        _to_consumable_array(new Set(makes)).flatMap(function(make) {
                            return {
                                make: make
                            };
                        })
                    ];
            }
        });
    });
    return _getTopMakes.apply(this, arguments);
}
function getTopModelForMake(make) {
    return _getTopModelForMake.apply(this, arguments);
}
function _getTopModelForMake() {
    _getTopModelForMake = _async_to_generator(function(make) {
        var links, models;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getLinks("car-reviews-v2/".concat(make.toLocaleLowerCase()))
                    ];
                case 1:
                    links = _state.sent();
                    models = Object.values(links).filter(function(link) {
                        return link.slug !== "car-reviews-v2";
                    }).filter(function(link) {
                        return link.is_folder;
                    }).filter(function(link) {
                        return link.slug.startsWith("car-reviews-v2/".concat(make));
                    }).map(function(link) {
                        return link.slug.replace("car-reviews-v2/".concat(make), "");
                    }).map(function(slug) {
                        return slug.replace("/", "").trim();
                    }).filter(function(link) {
                        return link !== "";
                    });
                    return [
                        2,
                        _to_consumable_array(new Set(models)).flatMap(function(model) {
                            return {
                                make: make,
                                model: model
                            };
                        })
                    ];
            }
        });
    });
    return _getTopModelForMake.apply(this, arguments);
}
